import DashboardFilters from "./dashboard-filters.vue";

export default DashboardFilters;



// WEBPACK FOOTER //
// ./src/components/_dashboard-filters/index.js